// JSX Runtime Polyfill for older React versions
// This polyfill provides jsx and jsxs functions for libraries that expect the new JSX transform
import * as React from 'react';

// Export jsx and jsxs functions
export const jsx = function (type, props, key) {
  const { children, ...restProps } = props || {};
  return React.createElement(
    type,
    key ? { ...restProps, key } : restProps,
    children
  );
};

export const jsxs = function (type, props, key) {
  const { children, ...restProps } = props || {};
  return React.createElement(
    type,
    key ? { ...restProps, key } : restProps,
    children
  );
};

// Also include Fragment export
export const Fragment = React.Fragment;

// Default export for modules that use import React from 'react/jsx-runtime'
export default {
  jsx,
  jsxs,
  Fragment
};
